// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";

var initState = {
  name: ""
};

function RemoveName(Props) {
  var updater = Props.updater;
  var match = React.useState(function () {
        return initState;
      });
  var setState = match[1];
  var state = match[0];
  var handleName = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (param) {
                  return {
                          name: a
                        };
                }));
  };
  var handleSubmit = function (e) {
    e.preventDefault();
    return Curry._1(updater, state.name);
  };
  return React.createElement("div", undefined, React.createElement("form", {
                  onSubmit: handleSubmit
                }, "Remove: ", React.createElement("input", {
                      className: "input-name",
                      name: "name",
                      type: "text",
                      value: state.name,
                      onChange: handleName
                    }), React.createElement("input", {
                      type: "submit",
                      value: "remove",
                      onClick: (function (param) {
                          
                        })
                    })));
}

var make = RemoveName;

export {
  initState ,
  make ,
  
}
/* react Not a pure module */
